import {
  type GetFeatureLimitNotificationsResponse,
  getFeatureLimitNotifications,
} from '@otter-ai/recall-client';
import type { AdditionalQueryOptions } from '@/shared/utils/queryCreators';

const queryKey = ['feature_limit_notifications'];

type AdditionalFeatureLimitNotificationsQueryOptions = AdditionalQueryOptions<
  GetFeatureLimitNotificationsResponse,
  typeof queryKey
>;

export type FeatureLimitNotificationsQuery = {
  readonly queryKey: typeof queryKey;
  readonly queryFn: () => Promise<GetFeatureLimitNotificationsResponse>;
} & AdditionalFeatureLimitNotificationsQueryOptions;

/**
 * Create a query to fetch feature limit notifications
 *
 * @example
 * ```tsx
 * const { data: featureLimits } = useQuery(featureLimitNotificationsQueryCreator());
 * ```
 */
export function featureLimitNotificationsQueryCreator(
  additionalOptions: AdditionalFeatureLimitNotificationsQueryOptions = {},
): FeatureLimitNotificationsQuery {
  return {
    ...additionalOptions,
    queryKey,
    queryFn: async () => {
      const response = await getFeatureLimitNotifications({
        throwOnError: true,
      });

      return response.data;
    },
  };
}
